export default "__VITE_ASSET__BIV4iEGr__"